import { RefObject } from "react";

import { Row, Col, Image } from "antd";
import guide1 from "assets/img/guide1.png";
import guide2 from "assets/img/guide2.png";
import guide3 from "assets/img/guide3.png";
import guide4 from "assets/img/guide4.png";
import guide5 from "assets/img/guide5.png";
import guide6 from "assets/img/guide6.png";

import { ReactComponent as IconShare } from "assets/icons/IconShare.svg";
import "./styles.scss";

interface ContainerProps {
  containerRef: RefObject<HTMLDivElement>;
}

export default function Container({ containerRef }: ContainerProps) {
  return (
    <div ref={containerRef} className="containner">
      <div className="containner-box">
        <h3 style={{ color: "#2a2a86", textAlign: "center", margin: "40px 0" }}>
          HƯỚNG DẪN LẤY LINK TẠI ĐÂY
        </h3>
        <span className="container-desc-title">
          LẤY LINK TRÊN TRÌNH DUYỆT WEB
        </span>
        <p className="container-desc-1">
          Nếu bạn sử dụng trình duyệt web, (Chrome, Cốc Cốc, Safari,...) bạn
          truy cập vào trang, nhóm muốn kiểm tra, copy tên miền đó. Sau đó truy
          cập vào
          <span className="container-desc-main">bvkh.yody.vn</span>, dán link
          vào ô tìm kiếm, bấm
          <span className="container-desc-main">KIỂM TRA</span>.
        </p>

        <Row className="containner-box-guide" gutter={16}>
          <Col
            xs={24}
            sm={24}
            lg={8}
            xl={8}
            xxl={8}
            className="containner-box-guide-col"
          >
            <Image src={guide1} width={295} height={189} />
            <p className="containner-box-guide-desc">
              <strong>B1</strong>: Truy cập vào trang, nhóm muốn kiểm tra
            </p>
          </Col>

          <Col
            xs={24}
            sm={24}
            lg={8}
            xl={8}
            xxl={8}
            className="containner-box-guide-col"
          >
            <Image src={guide2} width={295} height={189} />
            <p className="containner-box-guide-desc">
              <strong>B2</strong>: Chọn tất cả đường dẫn, chuột phải chọn sao
              chép. Hoặc bạn cũng có thể bấm tổ hợp phím Ctrl C
            </p>
          </Col>

          <Col
            xs={24}
            sm={24}
            lg={8}
            xl={8}
            xxl={8}
            className="containner-box-guide-col"
          >
            <Image src={guide3} width={295} height={189} />
            <p className="containner-box-guide-desc">
              <strong>B3</strong>: Truy cập vào
              <span className="container-desc-main">bvkh.yody.vn</span>, dán
              link vào ô tìm kiếm, bấm
              <span className="container-desc-main">KIỂM TRA</span>.
            </p>
          </Col>
        </Row>

        <div style={{ marginTop: "48px" }}>
          <span className="container-desc-title">
            LẤY LINK TRÊN TRÌNH DUYỆT MOBILE
          </span>

          <p className="container-desc-2">
            Nếu bạn sử dụng ứng dụng FACEBOOK trên điện thoại, bạn truy cập vào
            trang bán hàng cần kiểm tra, bấm vào biểu tượng
            <IconShare
              style={{ position: "relative", top: "2px", margin: "0 4px" }}
            />
            trên góc phải màn hình, chọn sao chép liên kết. Sau đó truy cập vào
            <span className="container-desc-main">bvkh.yody.vn</span>, dán link
            vào ô tìm kiếm, bấm
            <span className="container-desc-main">KIỂM TRA</span>.
          </p>
        </div>
        <Row className="containner-box-guide" gutter={16}>
          <Col
            xs={24}
            sm={24}
            lg={8}
            xl={8}
            xxl={8}
            className="containner-box-guide-col"
          >
            <Image src={guide4} width={295} height={480} />
            <p className="containner-box-guide-desc">
              <strong>B1</strong>: Truy cập vào trang, nhóm muốn kiểm tra
            </p>
          </Col>

          <Col
            xs={24}
            sm={24}
            lg={8}
            xl={8}
            xxl={8}
            className="containner-box-guide-col"
          >
            <Image src={guide5} width={295} height={480} />
            <p className="containner-box-guide-desc">
              <strong>B2</strong>: bấm vào biểu tượng{" "}
              <IconShare
                style={{ position: "relative", top: "2px", margin: "0 4px" }}
              />
              trên góc phải màn hình, 
              chọn sao chép liên kết
            </p>
          </Col>

          <Col
            xs={24}
            sm={24}
            lg={8}
            xl={8}
            xxl={8}
            className="containner-box-guide-col"
          >
            <Image src={guide6} width={295} height={480} />
            <p className="containner-box-guide-desc">
              <strong>B3</strong>: Truy cập vào
              <span className="container-desc-main">bvkh.yody.vn</span>, dán
              link vào ô tìm kiếm, bấm
              <span className="container-desc-main">KIỂM TRA</span>.
            </p>
          </Col>
        </Row>
      </div>
    </div>
  );
}
